import { savingStarted, savingFinished } from '../slices/savingIndicatorSlice';

// Async thunk type-prefixes that represent a background "save" worth surfacing in the header.
// Add to this list rather than wiring up toasts/state per-page as new auto-save features appear.
const SAVE_ACTION_PREFIXES = ['alertPreferences/update', 'auth/updateProfile', 'spots/update'];

const savingIndicatorMiddleware = (store) => (next) => (action) => {
  const result = next(action);

  const type = action?.type || '';
  const isSaveAction = SAVE_ACTION_PREFIXES.some((prefix) => type.startsWith(`${prefix}/`));

  if (isSaveAction) {
    if (type.endsWith('/pending')) {
      store.dispatch(savingStarted());
    } else if (type.endsWith('/fulfilled') || type.endsWith('/rejected')) {
      store.dispatch(savingFinished());
    }
  }

  return result;
};

export default savingIndicatorMiddleware;
